<template>
  <TeamsOverview action-id="1000strokes" :per-page="25">
    <template v-slot="{ row }">
      <div class="col-12 mb-4">
        <div class="kotk-team kotk-team--1000strokes-team view-mode--teaser" :data-id="row.drupal_internal__id">
          <div class="teaser">
            <a :href="[path, row.id].join('/')" class="teaser__url">
              <div class="teaser__content">
                <div class="teaser__title">{{ row.label }}</div>
                <div class="teaser__golfers">{{row.lat_start_participants_count}}</div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </template>
  </TeamsOverview>
</template>

<script>
import TeamsOverview from "@/components/Views/TeamsOverview.vue";

export default {
  name: "StrokesTeamsOverview",
  components: {
    TeamsOverview,
  },
  data() {
    let path = this.$window.location.pathname

    const pathSegments = path.split("/")
    const lastSegment = pathSegments[pathSegments.length - 1];

    if (lastSegment !== "steun-een-team") {
      path = `${path.replace(new RegExp("/$"),'')}/steun-een-team`
    }

    return {
      Drupal: this.$drupal,
      path: path,
    }
  }
}
</script>
